export default "__VITE_ASSET__Dlz76TzB__"